import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { InvoiceModel } from '@data-layer/models/entry-summaries';
import { enumDropdownActionIconColor, enumDropdownActionMenuMode } from '@shared/form-wrapper/enums';
import { HTS_MASK } from '@helpers/custom-validator';
import { DEFAULT_CURRENCY_CODE } from '@constants/currency';
import { ValidationMessageModel } from '@data-layer/models/common';
import { enumTransportationMode } from '@data-layer/enums/entry-summaries';
import { EsValidationsHelperService } from '../../services';

@Component({
  selector: 'es-details-invoice-card',
  templateUrl: './es-details-invoice-card.component.html',
  styleUrls: ['./es-details-invoice-card.component.scss'],
})
export class EsDetailsInvoiceCardComponent implements OnChanges {
  @Input() public transportationMode: enumTransportationMode;
  @Input() public invoice: InvoiceModel;
  @Input() public index: number;
  @Input() public canEdit: boolean = false;
  @Input() public allValidationMessages: ValidationMessageModel[] = [];
  @Input() public isRequiredDocument: boolean = true;

  @Output() public editInvoice: EventEmitter<number> = new EventEmitter();
  @Output() public removeInvoice: EventEmitter<number> = new EventEmitter();

  public HTS_MASK: string = HTS_MASK;
  public iconColor: enumDropdownActionIconColor = enumDropdownActionIconColor.DEFAULT;
  public menuMode: enumDropdownActionMenuMode = enumDropdownActionMenuMode.DEFAULT;
  public DEFAULT_CURRENCY_CODE: string = DEFAULT_CURRENCY_CODE;
  public validationMessages: ValidationMessageModel[] = [];
  public manufacturerValidationMessages: ValidationMessageModel[] = [];
  public linesValidationMessages: ValidationMessageModel[] = [];

  public isInvoiceConfirmModalOpen: boolean;

  constructor(private esValidationsHelperService: EsValidationsHelperService) {}

  /** #13499 — "#N" only when the parent BL has several invoices (then `index` is bound), empty otherwise. */
  public get indexSuffix(): string {
    return this.index > 0 ? ' #' + this.index : '';
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.invoice || changes.allValidationMessages) {
      this.getValidationMessages();
      this.getManufactureValidationMessages();
      this.getLinesValidationMessages();
    }
  }

  public goToEditInvoice() {
    this.editInvoice.emit(this.invoice.id);
  }

  public onDeleteInvoice() {
    this.removeInvoice.emit(this.invoice.id);
    this.isInvoiceConfirmModalOpen = false;
  }

  private getValidationMessages(): void {
    this.validationMessages = this.esValidationsHelperService.getValidationMessages(
      this.allValidationMessages,
      this.invoice,
      this.transportationMode,
    );
  }

  private getManufactureValidationMessages(): void {
    this.manufacturerValidationMessages = this.esValidationsHelperService.getManufactureValidationMessages(
      this.invoice,
      this.transportationMode,
    );
  }

  private getLinesValidationMessages(): void {
    this.linesValidationMessages = this.esValidationsHelperService.getLinesValidationMessages(this.invoice, this.transportationMode);
  }
}
